import React from "react";
import { MermaidDiagram } from "../MermaidDiagram/MermaidDiagram";
import styles from "./MarkdownComponents.module.css";
import { Components } from "react-markdown";

interface CodeComponentProps {
  className?: string;
  children: React.ReactNode;
  inline?: boolean;
  node?: {
    data?: {
      lang?: string;
      [key: string]: unknown;
    };
    properties?: {
      className?: string | string[];
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
}

export const code = (props: CodeComponentProps) => {
  const { className, children, node, inline } = props;

  // Extract language from className (format: "language-mermaid")
  const classNameMatch = /language-(\w+)/.exec(className || "");
  let language = classNameMatch ? classNameMatch[1] : "";

  // Fallback: check node.data.lang if available
  if (!language && node?.data?.lang) {
    language = node.data.lang;
  }

  // Fallback: check node.properties.className if available
  if (!language && node?.properties?.className) {
    const nodeClassName = Array.isArray(node.properties.className)
      ? node.properties.className.join(" ")
      : String(node.properties.className);
    const nodeMatch = /language-(\w+)/.exec(nodeClassName);
    if (nodeMatch) {
      language = nodeMatch[1];
    }
  }

  // Extract chart content - handle both string and array children
  const chartContent = Array.isArray(children)
    ? children.map((child: React.ReactNode) => String(child)).join("")
    : String(children);

  if (!inline && language === "mermaid") {
    return <MermaidDiagram chart={chartContent.replace(/\n$/, "")} />;
  }

  return !inline ? (
    <pre className={styles.codeBlock}>
      <code className={className}>{children}</code>
    </pre>
  ) : (
    <code className={styles.inlineCode}>{children}</code>
  );
};

export const markdownComponents = {
  code,
  table: ({ children }) => (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className={styles.thead}>{children}</thead>,
  tbody: ({ children }) => <tbody>{children}</tbody>,
  tr: ({ children }) => <tr className={styles.tr}>{children}</tr>,
  th: ({ children }) => <th className={styles.th}>{children}</th>,
  td: ({ children }) => <td className={styles.td}>{children}</td>,
} as Components;
